namespace SP {
    export interface ShipmentInfo {
        shipmentId: string;
        shipmentNo: string;
        fulfillmentLocation: string;
        shipmentState: ShipmentState;
        order: OrderInfo;
        lines: ShipmentLineInfo[];
        packages: PackageInfo[];
    }

}